import { updateCourierManagement } from '@lib/axios/courier'
import { useMutation, useQueryClient } from 'react-query'
import useSuccess from '@hooks/useSuccess'
import useCloseDialog from '@hooks/useCloseDialog'

const useUpdate = () => {
  const showSuccess = useSuccess('Sukses', 'Sukses Mengubah Kurir')
  const closeDialog = useCloseDialog()
  const queryClient = useQueryClient()
  const mutation = useMutation(
    (mdata) => updateCourierManagement(
      mdata.id,
      mdata.name,
      mdata.code,
      mdata.icon
    ),
    {
      onSuccess: () => {
        queryClient.invalidateQueries('courier')
      },
    }
  )

  return (data) => mutation.mutate(data, {
    onError: () => closeDialog(),
    onSuccess: () => {
      showSuccess()
    },
  })
}

export default useUpdate
